import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';

import Logo from '../Logo/Logo';
import SecondaryCTA from '../Buttons/SecondaryCTA/SecondaryCTA';

const Navbar = () => {

	return(
		<section className={styles.Navbar}>
			<div className='container d-flex justify-content-between align-items-center'>
				<Logo />
				<Link to='/interest'><SecondaryCTA>I'm Interested</SecondaryCTA></Link>
			</div>
		</section>
	)

}

export default Navbar